var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 5.8575V9.375H13.44C13.35 9.3675 13.155 9.255 13.11 9.1725L12.33 7.695C12.0225 7.11 11.49 6.78 10.92 6.81C10.35 6.84 9.8625 7.2225 9.615 7.845L8.58 10.44L8.43 10.05C8.0625 9.0975 7.0125 8.3775 5.9775 8.3775L1.5 8.4V5.8575C1.5 3.1275 3.1275 1.5 5.8575 1.5H12.1425C14.8725 1.5 16.5 3.1275 16.5 5.8575Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 12.1425V10.5H13.44C12.9375 10.5 12.345 10.14 12.1125 9.69749L11.3325 8.21999C11.1225 7.82249 10.8225 7.84499 10.6575 8.25749L8.9325 12.615C8.745 13.1025 8.43 13.1025 8.235 12.615L7.38 10.455C7.1775 9.92999 6.5475 9.50249 5.985 9.50249L1.5 9.52499V12.1425C1.5 14.8275 3.075 16.4475 5.7225 16.4925C5.805 16.5 5.895 16.5 5.9775 16.5H11.9775C12.09 16.5 12.2025 16.5 12.3075 16.4925C14.94 16.4325 16.5 14.82 16.5 12.1425Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.50004 9.52499V12.0075C1.48504 11.7675 1.47754 11.5125 1.47754 11.25V9.52499H1.50004Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "97120/static/media/Health.a4f2e1905d0b19e01f13003dba8a8c24.svg";
export { ForwardRef as ReactComponent };